import EditorConstants from '../constants/editor-constants'
import AppConstants from '../constants/app-constants'
import AppDispatcher from '../dispatcher/app-dispatcher'


var EditorActions = {
	setBatchQuantity: function(value) {
		AppDispatcher.handleViewAction({
			actionType: EditorConstants.SET_BATCH_QUANTITY,
			value: value
		});
	},

	setOrderItemProduct: function(itemId, productId, productWidth, productHeight) {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.SET_ORDER_ITEM_PRODUCT,
			productId: productId,
			itemId: itemId,
			productWidth: productWidth,
			productHeight: productHeight
		});
	},

	toggleItemOption: function(itemId, optionName, data) {
		AppDispatcher.handleViewAction({
			actionType: EditorConstants.TOGGLE_PRODUCT_OPTION,
			optionName: optionName,
			itemId: itemId,
			data: data
		});
	},

	batchFilterValue: function(filterValue) {
		AppDispatcher.handleViewAction({
			actionType: EditorConstants.APPLY_FILTER_TO_BATCH,
			filterValue: filterValue
		});
	},

	batchProduct: function(productId, productWidth, productHeight) {
		AppDispatcher.handleViewAction({
			actionType: EditorConstants.SET_PRODUCT_BATCH,
			productId: productId,
			productWidth: productWidth,
			productHeight: productHeight
		});
	},

	resetItemOptions: function(item) {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.RESET_ITEM_OPTIONS,
			item: item
		});
	},
	cancelItemChanges: function(item) {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.CANCEL_ITEM_CHANGES,
			item: item
		});
	},
	setSwipePreviewItem: function(itemId) {
		AppDispatcher.handleViewAction({
			actionType: 'setSwipePreviewItem',
			itemId: itemId
		});
	},
	setItemLabel: function(item, label) {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.SET_ITEM_LABEL,
			item: item,
			label: label
		});
	},
	setCropLowresWarningSeen: function (seen) {
		AppDispatcher.handleViewAction({
			actionType: AppConstants.SET_CROP_LOWRES_WARNING_SEEN,
			seen: seen
		});
	}
};

export default EditorActions;
